import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EdlProficiencyPickerOptions, SessionService } from '@edl-development/edl-common';
import { EdlTooltipIcon } from 'src/app/components/common-components/enum/edl-tooltip-icon.enum';
import { GenericType } from 'src/app/model/base/edl-generic-type.model';
import { ObservationTypes } from 'src/app/model/enum/observation-types.enum';
import { DomainFilterType } from 'src/app/model/enum/observations/domain-filter-type.enum';
import { Domain } from 'src/app/model/enum/observations/domain.enum';
import { RubricResponse } from 'src/app/model/enum/rubric/rubric-response.enum';
import { SubdomainLookup } from 'src/app/model/interfaces/SubdomainLookup.interface';
import { NtpeModel } from 'src/app/model/observation/ntpe/ntpe.model';
import { ObservationSummaryDTO } from 'src/app/model/observation/observation-summary-dto.model';
import { ObservationLookUpTypes } from 'src/app/observations/helpers/observation-lookup-types/observation-lookup-types.helper';
import { DEFAULT_RUBRIC_LANGUAGE_LINK } from 'src/app/properties/observations/rubric/rubric.constants';
import { ResourceService } from 'src/app/services/resource/resource.service';

@Component({
    selector: 'app-ntpe-rubric-subdomain-form',
    templateUrl: './ntpe-rubric-subdomain-form.component.html',
    styleUrls: ['./ntpe-rubric-subdomain-form.component.scss']
})
export class NtpeRubricSubdomainFormComponent implements OnInit {
    @Input() rubricComponent?: SubdomainLookup;
    @Input() observationDetails?: NtpeModel;
    @Input() observationSummary?: ObservationSummaryDTO;
    @Input() showTargetUser: boolean = false;
    @Input() form!: FormGroup;
    @Input() filterType?: DomainFilterType;

    observationType?: GenericType;
    resourceFilePath?: string;
    rubricResponses: EdlProficiencyPickerOptions[] = [];
    rubricLanguageLink: string = DEFAULT_RUBRIC_LANGUAGE_LINK;

    EdlTooltipIcon = EdlTooltipIcon;
    RubricResponse = RubricResponse;
    DomainFilterType = DomainFilterType;

    constructor(private sessionService: SessionService, private resourceService: ResourceService) { }

    ngOnInit(): void {
        this.observationType = ObservationTypes.GetObservationType(this.observationSummary?.itemType);
        this.resourceFilePath = this.resourceService.getNTPEFilePath(this.observationDetails?.targetUserRole?.shortName);
        this.rubricLanguageLink = this.resourceService.getCachedData(this.resourceFilePath, 'RubricPDF.Text') ?? DEFAULT_RUBRIC_LANGUAGE_LINK;

        const resourceData = this.resourceService.getCachedResourceData(this.resourceFilePath);
        this.rubricResponses = ObservationLookUpTypes.generateRubricResponses(resourceData, this.rubricComponent?.Key ?? '');
    }

    showTargetUserRating() {
        return this.sessionService.user?.UserID === this.observationDetails?.targetUserId || this.showTargetUser;
    }

    showEvalutatorRating() {
        return this.sessionService.user?.UserID === this.observationDetails?.evaluatingUserId || this.observationDetails?.evalRatedDate || 
        !(this.sessionService.user?.UserID === this.observationDetails?.targetUserId);
    }

    getRubricResponseForDomain(observation?: NtpeModel, domain?: Domain, userId?: string) {
        let unfilteredDomainResponses = userId == observation?.evaluatingUserId ? observation?.evalNTPEObservationDomains : observation?.targetNTPEObservationDomains;

        const responses = unfilteredDomainResponses?.filter(r => r.domain === domain) ?? [];
        return responses;//?.find(r => r.user?.userID === userId);
    }

    getRubricResponse(isEvaluator: boolean) {
        return this.form.get(isEvaluator ? 'principalResponse' : 'teacherResponse');
    }

    isChecked(isEvaluator: boolean) {
        return this.getRubricResponse(isEvaluator)?.value === RubricResponse.INAPPLICABLE;
    }

    isResponseDisabled(isEvaluator: boolean) {
        return this.getRubricResponse(isEvaluator)?.disabled;
    }

    onCheckboxClicked(isEvaluator: boolean, $event: any) {
        const isChecked = $event?.srcElement?.checked;

        const rubricResponse = this.getRubricResponse(isEvaluator);
        rubricResponse?.setValue(isChecked ? RubricResponse.INAPPLICABLE : RubricResponse.UNSELECTED);
        rubricResponse?.updateValueAndValidity();
    }
}
